import Vue from 'vue'
import Vuex from 'vuex'
import actions from 'brave-vuex/actions'
// TODO: setup form scaffolding and a programmatic way of defining "brave-forms"
export default function initializeStore() {
  Vue.use(Vuex)
  let state = {
    count: 42,
    modals: [

    ]
  }
  let mutations = {
    INCREMENT (state) {
      state.count++
    },
    pushModal (state, {component, props = {}}) {
      state.modals.push({component, props})
      document.documentElement.classList.add('viewing-modal')
    },
    popModal (state) {
      state.modals.pop()
      if (state.modals.length == 0) {
        window.setTimeout(function () {
          document.documentElement.classList.remove('viewing-modal')
        }, 200)
      }
    }
  }
  return new Vuex.Store({
    state,
    mutations,
    actions
  })

}


// WEBPACK FOOTER //
// ./lib/brave-vuex/initializeStore.js